import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CloneEvaluationCriteriaUseCaseInterface } from 'domain/usecases';

export class RemoteCloneEvaluationCriteria
  implements CloneEvaluationCriteriaUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: CloneEvaluationCriteriaUseCaseInterface.Params,
  ): Promise<CloneEvaluationCriteriaUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/clone`,
      method: 'post',
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
